import { httpV1 as http } from '../api';

const CONTEXT = '/bms/fgts';

export async function consult(params) {
  return http.get(`${CONTEXT}/balance`, { params });
}

export async function simulation(data) {
  return http.post(`${CONTEXT}/simulation`, data);
}

export async function tryAgain(data) {
  return http.post(`${CONTEXT}/credit-operation`, data);
}

export async function verify(params) {
  return http.get(`${CONTEXT}/proposal`, { params });
}

export async function cancel(data) {
  return http.post(`${CONTEXT}/cancel`, data);
}
